// extracted by mini-css-extract-plugin
module.exports = {"img404":"Login_img404__3Ys1Y"};